import React from 'react';

export function DateTextInput({
  className = '',
  placeholder = 'yyyy-MM-dd',
  ...inputProps
}) {
  return (
    <input
      {...inputProps}
      type="text"
      inputMode="numeric"
      pattern="\d{4}-\d{2}-\d{2}"
      placeholder={placeholder}
      className={className}
    />
  );
}
